import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_UNREAD_COUNT_REQUEST,
  FETCH_UNREAD_COUNT_SUCCESS,
  FETCH_UNREAD_COUNT_FAILURE,
  MARK_ONE_READ_REQUEST,
  MARK_ONE_READ_SUCCESS,
  MARK_ONE_READ_FAILURE,
  MARK_ALL_READ_REQUEST,
  MARK_ALL_READ_SUCCESS,
  MARK_ALL_READ_FAILURE,
  ARCHIVE_NOTIFICATION_REQUEST,
  ARCHIVE_NOTIFICATION_SUCCESS,
  ARCHIVE_NOTIFICATION_FAILURE,
  SET_DRAWER_OPEN,
  RESET,
} from "./constants";

const initialState = {
  // Notification list
  notificationsLoading: false,
  notificationsData: [],
  notificationsError: null,
  pagination: null,

  // Unread count (badge)
  unreadCount: 0,
  unreadCountLoading: false,

  // Per-item mutation loading
  markingReadId: null,
  archivingId: null,
  markingAllRead: false,

  // Drawer UI state
  drawerOpen: false,
};

export default function notificationsReducer(state = initialState, action) {
  switch (action.type) {
    // ── List ────────────────────────────────────────────────────────────────
    case FETCH_NOTIFICATIONS_REQUEST:
      return { ...state, notificationsLoading: true, notificationsError: null };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notificationsLoading: false,
        notificationsData: action.payload?.data ?? action.payload ?? [],
        pagination: action.payload?.pagination ?? null,
      };
    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        notificationsLoading: false,
        notificationsError: action.payload,
      };

    // ── Unread count ─────────────────────────────────────────────────────────
    case FETCH_UNREAD_COUNT_REQUEST:
      return { ...state, unreadCountLoading: true };
    case FETCH_UNREAD_COUNT_SUCCESS:
      return {
        ...state,
        unreadCountLoading: false,
        unreadCount: action.payload?.count ?? 0,
      };
    case FETCH_UNREAD_COUNT_FAILURE:
      return { ...state, unreadCountLoading: false };

    // ── Mark one read ────────────────────────────────────────────────────────
    case MARK_ONE_READ_REQUEST:
      return { ...state, markingReadId: action.payload };
    case MARK_ONE_READ_SUCCESS:
      return {
        ...state,
        markingReadId: null,
        notificationsData: state.notificationsData.map((n) =>
          n.id === action.payload ? { ...n, read: true, read_at: new Date().toISOString() } : n
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
      };
    case MARK_ONE_READ_FAILURE:
      return { ...state, markingReadId: null };

    // ── Mark all read ────────────────────────────────────────────────────────
    case MARK_ALL_READ_REQUEST:
      return { ...state, markingAllRead: true };
    case MARK_ALL_READ_SUCCESS:
      return {
        ...state,
        markingAllRead: false,
        notificationsData: state.notificationsData.map((n) => ({
          ...n,
          read: true,
          read_at: n.read_at || new Date().toISOString(),
        })),
        unreadCount: 0,
      };
    case MARK_ALL_READ_FAILURE:
      return { ...state, markingAllRead: false };

    // ── Archive ──────────────────────────────────────────────────────────────
    case ARCHIVE_NOTIFICATION_REQUEST:
      return { ...state, archivingId: action.payload };
    case ARCHIVE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        archivingId: null,
        notificationsData: state.notificationsData.filter(
          (n) => n.id !== action.payload
        ),
      };
    case ARCHIVE_NOTIFICATION_FAILURE:
      return { ...state, archivingId: null };

    // ── Drawer ───────────────────────────────────────────────────────────────
    case SET_DRAWER_OPEN:
      return { ...state, drawerOpen: action.payload };

    case RESET:
      return initialState;

    default:
      return state;
  }
}
